import React from "react";
import { Config, Metadata, MetadataDict } from "../types";
import resourceInfo from "../resourceInfo.json";

export default function ResourceInfo({
  config,
  setConfig,
  metadataDict,
}: {
  config: Config;
  setConfig: React.Dispatch<React.SetStateAction<Config>>;
  metadataDict: MetadataDict;
}) {
  // @ts-ignore
  const thisResourceInfo = resourceInfo[config.selectedResource];

  const regionMetadata = Array.from({ length: 103 }, (x, i) => i)
    .slice(1)
    .map((i) => {
      return metadataDict[i].resourceId === config.selectedResource ? metadataDict[i] : undefined;
    })
    .filter((item) => item !== undefined);

  const selectedRegionMetadata =
    config.selectedRegion && regionMetadata.find((metadata) => metadata?.id === config.selectedRegion);

  return (
    <>
      <div className="resource-info-layout">
        <>
          <div className="footer-container">
            <h2>{thisResourceInfo.name}</h2>
            <h3>Resource #{config.selectedResource}</h3>
            <div style={{ backgroundColor: thisResourceInfo.color, width: "100%", height: "10px" }} />
            <p>
              Maps to: {thisResourceInfo.mapsTo} <br /> ({thisResourceInfo.hemisphere} hemisphere)
            </p>
          </div>

          <div className="footer-container">
            <h4>Brain regions</h4>
            <div
              className="regions-choose"
              style={{ display: "flex", flexDirection: "column", overflowY: "scroll", maxHeight: "15vh" }}
            >
              {regionMetadata.map((metadata) => {
                return metadata ? (
                  <div key={metadata?.id + "list"}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setConfig({ ...config, selectedRegion: e.target.checked ? metadata.id : undefined });
                      }}
                      checked={config.selectedRegion === metadata.id}
                    />
                    <span style={{ marginRight: 30 }}>
                      [{metadata.id}] {metadata.name} (
                      {thisResourceInfo.hemisphere === "right" ? metadata.mindboggleId : metadata.mindboggleId - 1000})
                    </span>
                  </div>
                ) : undefined;
              })}
            </div>
          </div>
        </>
      </div>
      <div className="region-info-layout">
        {config.selectedRegion && selectedRegionMetadata && (
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <h2>{selectedRegionMetadata?.name}</h2>

            <div style={{ display: "flex" }}>
              <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                <p>
                  Region id: {selectedRegionMetadata.id} <br /> Mindboggle id:{" "}
                  {selectedRegionMetadata.isRightHemisphere
                    ? selectedRegionMetadata.mindboggleId
                    : selectedRegionMetadata.mindboggleId - 1000}
                </p>
              </div>
              <p style={{ marginLeft: "30px" }}>
                {selectedRegionMetadata.isRightHemisphere ? "Right" : "Left"} hemisphere <br /> Resource id:
                {selectedRegionMetadata.resourceId}{" "}
              </p>
            </div>
            <button
              style={{ cursor: "pointer" }}
              onClick={() => {
                setConfig({ ...config, selectedRegion: undefined });
              }}
            >
              Reset selected region
            </button>
          </div>
        )}
      </div>
    </>
  );
}
